import type { WheelSpinStatus } from '@/api/types';

export const STATUS_LABEL: Record<WheelSpinStatus, string> = {
  granted: 'Granted',
  failed: 'Failed',
  pending_choice: 'Pending choice',
  declined: 'Declined',
  drawn: 'Drawn',
};

export const STATUS_HELP: Record<WheelSpinStatus, string> = {
  granted: 'Prize credited to the player.',
  failed: 'Draw made, credit failed — check the Slack alert and credit by hand.',
  pending_choice: 'Won while holding a deposit bonus; the player has not chosen replace or keep yet.',
  declined: 'The player kept their current bonus instead of this prize.',
  drawn: 'Draw recorded but the outcome was never settled — investigate.',
};
